import type { ActivityModule } from '../../core/activity';
import { mountCalcudoku } from './ui';
import levelsData from './levels.json';
import './style.css';

export const calcudoku: ActivityModule = {
  id: 'calcudoku',
  title: 'Calcudoku',
  description: 'Sudoku matemático. Preencha 1..N por linha/coluna respeitando o resultado de cada gaiola.',
  ageMin: 8,
  ageMax: 11,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/calcudoku/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountCalcudoku,
};
